import React, { useCallback, useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import { api, fmtError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { fmtDate, L } from "@/constants/labels";

export default function Messages() {
  const { user } = useAuth();
  const [sp] = useSearchParams();
  const [threads, setThreads] = useState([]);
  const [active, setActive] = useState(sp.get("open") || null);
  const [to, setTo] = useState(sp.get("to") || null);
  const [msgs, setMsgs] = useState([]);
  const [text, setText] = useState("");

  const loadThreads = useCallback(async () => {
    const { data } = await api.get("/messages/threads");
    setThreads(data);
    setActive((prev) => (prev ?? (data[0]?.thread_id ?? null)));
    setTo((prev) => (prev ?? (data[0]?.other_user_id ?? null)));
  }, []);
  useEffect(() => { loadThreads(); }, [loadThreads]);
  useEffect(() => {
    (async () => {
      if (!active) return;
      const { data } = await api.get(`/messages/thread/${active}`);
      setMsgs(data);
      if (!to && data.length) setTo(data[0].from_user_id === user.id ? data[0].to_user_id : data[0].from_user_id);
    })();
  }, [active, user, to]);

  const send = async (e) => {
    e.preventDefault(); if (!text || !to || !active) return;
    try {
      await api.post("/messages", { thread_id: active, to_user_id: to, body: text });
      setText(""); const { data } = await api.get(`/messages/thread/${active}`); setMsgs(data);
      loadThreads();
    } catch (err) { toast.error(fmtError(err)); }
  };

  return (
    <div>
      <h1 className="text-2xl md:text-3xl font-semibold text-[#1F2933]">Messages</h1>
      <div className="mt-4 grid md:grid-cols-3 gap-3">
        <div className="card md:col-span-1 overflow-hidden">
          <div className="p-2 border-b border-[#E4E7EB] font-semibold text-[#1F2933]">Conversations</div>
          <ul>
            {threads.length === 0 && <li className="p-3 text-sm text-[#3E4C59]">Aucun échange.</li>}
            {threads.map(t => (
              <li key={t.thread_id}>
                <button onClick={() => { setActive(t.thread_id); setTo(t.other_user_id); }}
                  className={`w-full text-left p-3 border-b border-[#E4E7EB] ${active === t.thread_id ? "bg-[#F5F6F7]" : "bg-white"}`}
                  data-testid={`thread-${t.thread_id}`}>
                  <div className="text-sm font-semibold text-[#1F2933]">{t.other_nom}</div>
                  <div className="text-xs text-[#3E4C59] truncate">{t.last_body}</div>
                  <div className="text-[10px] text-[#3E4C59]">{fmtDate(t.last_at)}</div>
                </button>
              </li>
            ))}
          </ul>
        </div>
        <div className="card md:col-span-2 flex flex-col min-h-[60vh]">
          <div className="flex-1 p-3 overflow-y-auto space-y-2">
            {msgs.length === 0 && <div className="text-sm text-[#3E4C59]">{active ? "Aucun message dans ce fil." : "Sélectionnez une conversation."}</div>}
            {msgs.map(m => (
              <div key={m.id} className={`max-w-[80%] px-3 py-2 rounded-[4px] text-sm ${m.from_user_id === user.id ? "ml-auto bg-[#1B3A5C] text-white" : "bg-[#F5F6F7] text-[#1F2933]"}`}>
                <div>{m.body}</div>
                <div className={`text-[10px] mt-1 ${m.from_user_id === user.id ? "text-white/70" : "text-[#3E4C59]"}`}>{fmtDate(m.created_at)}</div>
              </div>
            ))}
          </div>
          <form onSubmit={send} className="border-t border-[#E4E7EB] p-2 flex gap-2">
            <input className="input" value={text} onChange={(e) => setText(e.target.value)} placeholder="Écrire un message…" data-testid="msg-input" />
            <button className="btn-primary" disabled={!text || !active || !to} data-testid="msg-send">{L.common.submit}</button>
          </form>
        </div>
      </div>
    </div>
  );
}
